function formatMoney(number) {
    if (number === null || number === undefined || number === '') {
        return ''
    }

    number = String(number)
    number = number.replace(/,/g,"");
    number = parseFloat(number)

    if (Number.isNaN(number)) {
        return ''
    }

    return number.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
}

export { formatMoney }
